import { Button } from "~/components/ui/button";
import {
  AlertDialog,
  AlertDialogClose,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogPopup,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog";
import { RESPONSIVE_TEXT_BUTTON_CLASS } from "~/lib/touchTarget";

interface ProjectMilestoneDeleteDialogProps {
  readonly open: boolean;
  readonly mutating: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onConfirm: () => Promise<void>;
}

export function ProjectMilestoneDeleteDialog(props: ProjectMilestoneDeleteDialogProps) {
  return (
    <AlertDialog open={props.open} onOpenChange={props.onOpenChange}>
      <AlertDialogPopup>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete this milestone?</AlertDialogTitle>
          <AlertDialogDescription>
            The milestone will be removed. Its linked tasks will remain on the project without a
            milestone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogClose render={<Button variant="outline" />}>Cancel</AlertDialogClose>
          <Button
            variant="destructive"
            className={RESPONSIVE_TEXT_BUTTON_CLASS}
            disabled={props.mutating}
            onClick={() => void props.onConfirm()}
          >
            {props.mutating ? "Deleting…" : "Delete milestone"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogPopup>
    </AlertDialog>
  );
}
